var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewPattern3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.01 171.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d8d8d8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_3",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,32.54H93.7a0,0,0,0,1,0,0V138.27a0,0,0,0,1,0,0H17a2,2,0,0,1-2-2V34.54A2,2,0,0,1,17,32.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.87,32.54h52.8a2,2,0,0,1,2,2V92.05a0,0,0,0,1,0,0h-54.8a0,0,0,0,1,0,0V32.54A0,0,0,0,1,105.87,32.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.87,100.11h54.8a0,0,0,0,1,0,0v36.17a2,2,0,0,1-2,2h-52.8a0,0,0,0,1,0,0V100.11A0,0,0,0,1,105.87,100.11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPattern3);
export default __webpack_public_path__ + "static/media/viewPattern3.3c55f0b85d01f6282d6d1b03898c12bf.svg";
export { ForwardRef as ReactComponent };